<template>
  <div class="orders">
    <Header pageTitle="我的订单" />
    <div class="van_tabs">
      <van-tabs
        title-active-color="#3A82F8"
        color="#3A82F8"
        v-model="type"
        @change="tabChange"
      >
        <van-tab title="全部" name="0"></van-tab>
        <van-tab title="待付款" name="1"></van-tab>
        <van-tab title="待发货" name="3"></van-tab>
        <van-tab title="待收货" name="4"></van-tab>
      </van-tabs>
    </div>
    <div v-if="orderListData.length || loading" class="orderList">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="orderListData.length > 0 ? '没有更多了' : ''"
        @load="ordersList(true)"
      >
        <div
          class="list_2"
          v-for="orderInfo in orderListData"
          :key="orderInfo.id"
        >
          <div class="list-items_1-0">
            <div @click="orderDetail(orderInfo)">
              <div class="text-wrapper_5-0">
                <span class="text_8-0">{{ orderInfo.shopName }}</span>
                <span class="text_9-0">{{ orderInfo.statusString }}</span>
              </div>
              <!-- 主订单 -->
              <div v-if="orderInfo.isPrimaryOrder" class="primary-order">
                <OrderItem
                  v-for="(item, index) in orderInfo.subOrderList"
                  :key="item.id"
                  :order-info="item"
                  :index="index"
                />
              </div>
              <!-- 子订单 -->
              <OrderItem v-else :order-info="orderInfo" />
              <div class="text-wrapper_3-0">
                <span
                  v-if="
                    orderInfo.status == 1 ||
                    orderInfo.status == 6 ||
                    orderInfo.status == 7
                  "
                  class="text_13-0"
                  >应付款：</span
                >
                <span v-else class="text_13-0">实付款：</span>
                <span class="text_14-0">¥</span>
                <span class="text_15-0">{{ orderInfo.totalAmount }}</span>
              </div>
            </div>
            <!-- 待发货和已完成暂不显示按钮 -->
            <div
              class="block_4-0"
              v-show="orderInfo.status != 3 && orderInfo.status != 5"
            >
              <!-- 已关闭订单（订单过期或者取消）显示删除按钮 -->
              <div v-if="isDeleteBtn(orderInfo)">
                <!-- 订单分主订单，子订单；当前版本没有主订单，删除操作只涉及子订单 传递子订单编号 -->
                <button class="button_2-0" @click="delSubOrder(orderInfo)">
                  <span class="text_17-0">删除订单</span>
                </button>
              </div>
              <!-- 待付款订单 -->
              <div v-else-if="orderInfo.status == 1">
                <button
                  class="button_2-0"
                  @click="cancelOrder(orderInfo.payBatchId)"
                >
                  <span class="text_17-0">取消订单</span>
                </button>
                <button class="button_3-0" @click="orderDetail(orderInfo)">
                  <span class="text_18-0">立即付款</span>
                </button>
              </div>
              <!-- 已发货/待收货 -->
              <div
                v-else-if="!orderInfo.isPrimaryOrder && orderInfo.status == 4"
              >
                <button class="button_3-0" @click="confirmReceipt(orderInfo)">
                  <span class="text_18-0">确认收货</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div v-else class="orderList">
      <van-empty description="暂无相关订单数据" />
    </div>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header/index.vue";
import OrderItem from "./components/OrderItem.vue";
import { Dialog } from "vant";
export default {
  name: "orders",
  components: {
    Header,
    OrderItem,
  },
  data() {
    return {
      // van-tabs 绑定标签页标识（1，2，3，4，5）
      type: 2,

      // 订单查询参数
      orderParams: {
        condition: "MY",
        // 用户id/名称
        userId: null,
        // 订单状态
        orderStatus: null,
        // 分页 默认20条
        pageNo: 1,
        // pageSize: 10,
      },

      // 订单列表数据
      orderListData: [],
      // 列表加载状态（上拉加载更多）
      loading: false,
      finished: false,
    };
  },
  created() {
    this.type = this.$route.query.type ? `${this.$route.query.type}` : "0";
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.orderParams.userId = userInfo.user.id;
    this.orderParams.orderStatus = this.$route.query.type
      ? this.$route.query.type
      : null;
    this.ordersList();
  },

  methods: {
    // 切换tab标签，查询不同类型订单列表 name：标识符，title：标题
    tabChange(name, title) {
      console.log(name, "name");
      // this.orderParams.pageNo = 1;
      switch (name) {
        // 查询全部
        case "0":
          // this.orderParams.orderStatus = null;
          this.$router.replace({ path: this.$route.path });
          break;
        // 查询待付款
        case "1":
          // this.orderParams.orderStatus = 1;
          this.$router.replace({ path: this.$route.path, query: { type: 1 } });
          break;
        // 查询待发货
        case "3":
          // this.orderParams.orderStatus = 3;
          this.$router.replace({ path: this.$route.path, query: { type: 3 } });
          break;
        // 查询待收货
        case "4":
          // this.orderParams.orderStatus = 4;
          this.$router.replace({ path: this.$route.path, query: { type: 4 } });
          break;
        /*
          // 查询待评价
        case 5:
          this.orderParams.orderStatus = null;
          break;
          */
      }
      // this.ordersList();
    },
    // 查询订单信息
    async ordersList(isLoadMore) {
      const _this = this;
      _this.loading = true;
      if (isLoadMore) {
        _this.orderParams.pageNo += 1;
        // 加载状态开始
        this.finished = false;
      } else {
        _this.orderParams.pageNo = 1;
      }
      var res = await _this.$apis.myServe.ordersList(_this.orderParams);
      console.log(res);
      if (res.resultCode == 200) {
        // 上拉加载更多
        if (isLoadMore) {
          for (let i = 0; i < res.data.list.length; i++) {
            this.orderListData.push(res.data.list[i]);
          }
          // 加载状态结束
          this.finished = res.data.list.length < 20;
        } else {
          _this.orderListData = res.data.list;
        }
        this.loading = false;
      } else {
        _this.$toast(res.resultDesc);
      }
    },
    // 是否显示删除按钮
    isDeleteBtn(orderInfo) {
      let flag = false;
      if (
        (!orderInfo.isPrimaryOrder && [6, 7, 11].includes(orderInfo.status)) ||
        (orderInfo.isPrimaryOrder && [4, 6, 11].includes(orderInfo.status))
      ) {
        flag = true;
      }
      return flag;
    },
    // 删除订单
    async delSubOrder(orderInfo) {
      const { id, payBatchId, isPrimaryOrder } = orderInfo;
      Dialog.confirm({
        message: "确认删除该订单？",
        confirmButtonColor: "#4A79F1",
        cancelButtonText: "取消",
        confirmButtonText: "确认删除",
        className: "confirm-receipt",
      })
        .then(async () => {
          if (isPrimaryOrder) {
            var res = await this.$apis.myServe.delPrimaryOrder({
              payBatchId,
            });
            if (res.resultCode == 200) {
              this.ordersList();
            } else {
              this.$toast(res.resultDesc);
            }
          } else {
            var res = await this.$apis.myServe.delSubOrder({
              orderId: id,
            });
            if (res.resultCode == 200) {
              this.ordersList();
            } else {
              this.$toast(res.resultDesc);
            }
          }
        })
        .catch(() => {});
    },
    // 取消订单
    async cancelOrder(payBatchId) {
      const _this = this;
      Dialog.confirm({
        message: "确认取消该订单？",
        confirmButtonColor: "#4A79F1",
        cancelButtonText: "取消",
        confirmButtonText: "确认取消",
        className: "confirm-receipt",
      })
        .then(async () => {
          var res = await _this.$apis.myServe.cancelOrder({
            payBatchId: payBatchId,
          });
          if (res.resultCode == 200) {
            _this.ordersList();
          } else {
            _this.$toast(res.resultDesc);
          }
        })
        .catch(() => {});
    },
    to() {
      window.history.go(-1);
    },
    // 待付款订单，查询主订单详情获取支付过期时间，其他状态查询子订单详情
    orderDetail(orderInfo) {
      const id = orderInfo.isPrimaryOrder
        ? orderInfo.payBatchId
        : orderInfo.goodsList[0].orderId;
      if ([2, 8].includes(orderInfo.orderType)) {
        window.open(
          this.$global.meetingH5Url +
            `pagesModule/orderDetails/index?type=8&id=${id}${
              orderInfo.isPrimaryOrder ? "&isPrimaryOrder=true" : ""
            }`,
          "_self"
        );
      } else {
        // 会议稿件和会议
        if (orderInfo.isPrimaryOrder) {
          this.$router.push({
            path: "/orderDetails",
            query: { id: id, isPrimaryOrder: true },
          });
        } else {
          this.$router.push({
            path: "/orderDetails",
            query: { id: id },
          });
        }
      }
    },
    // 确认收货
    confirmReceipt(orderInfo) {
      const _this = this;
      Dialog.confirm({
        message: "是否确认收货",
        confirmButtonColor: "#4A79F1",
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        className: "confirm-receipt",
      })
        .then(async () => {
          const res = await _this.$apis.myServe.receiptConfirm({
            id: orderInfo.id,
          });
          if (res.resultCode == 200) {
            _this.ordersList();
          } else {
            _this.$toast(res.resultDesc);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
html,
body {
  background: #f5f5f5;
}

.orders {
  width: 100%;
  height: 100%;
  padding-top: calc(constant(safe-area-inset-top) + 44px) !important;
  padding-top: calc(env(safe-area-inset-top) + 44px) !important;

  .mycourse_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;

    .my {
      width: 72px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }

  .orderList {
    width: 100%;

    .list_2 {
      margin: 0 auto;
      margin-top: 12px;
      width: 94%;
      background: #fff;
      padding-bottom: 12px;
      border-radius: 8px;

      .list-items_1-0 {
        margin: 0 auto;
        width: 94%;
        background: #fff;

        .text-wrapper_5-0 {
          width: 94%;
          height: 45px;
          line-height: 45px;

          .text_8-0 {
            float: left;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .text_9-0 {
            float: right;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff3d3d;
          }
        }

        .block_3-0 {
          height: 90px;

          .image-text_2-0 {
            float: left;

            .box_4-0 {
              width: 80px;
              height: 80px;
              float: left;

              img {
                width: 80px;
                height: 80px;
                float: left;
              }
            }

            .text-group_2-0 {
              float: left;
              width: 204px;
              margin-left: 10px;

              .text_10-0 {
                font-size: 15px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .text_11-0 {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                margin-top: 10px;
              }
            }
          }

          .text_12-0 {
            float: right;
            margin: 31px auto;
          }
        }

        .text-wrapper_3-0 {
          width: 100%;
          height: 40px;
          line-height: 40px;
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .text_13-0 {
            float: left;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .text_14-0 {
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            float: left;
          }

          .text_15-0 {
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            float: left;
          }
        }

        .block_4-0 {
          width: 100%;
          text-align: right;

          .button_2-0 {
            width: 80px;
            height: 32px;
            border-radius: 16px;
            border: 1px solid #cccccc;

            border: none;

            .text_17-0 {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }
          }

          .button_3-0 {
            border: none;
            width: 80px;
            height: 32px;
            background: #397bf9;
            border-radius: 16px;

            margin-left: 10px;

            .text_18-0 {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  .confirm-receipt {
    .van-goods-action-button--first {
      width: 130px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #999999;
      background-color: #fff;
      color: #333;
      margin-right: 15px;
    }

    .van-goods-action-button--last {
      width: 130px;
      height: 40px;
      background: #4a79f1;
      border-radius: 20px;
      color: #fff;
    }
  }
}
</style>
